module.exports = __webpack_public_path__ + "static/img/bg_coupon_box.ddd8513.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/coupon/bg_coupon_box.png
// module id = 324
// module chunks = 32